var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-btn',{attrs:{"text":""}},[_c('h1',[_vm._v("良いおこない")])]),_c('v-btn',{attrs:{"text":""}},[_c('h1',[_vm._v("悪いおこない")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }